// @ts-nocheck
import { useState, useEffect } from 'react';
import { Slider } from 'primereact/slider';

export const TerrainSiderComponents = (props) => {
    const [terrainAlpha, setTerrainAlpha] = useState(0);

    useEffect(() => {
        setTerrainAlpha(Math.round((1 - window.main.OView.terrainAlpha) * 100))
    }, []);

    useEffect(() => {
        window.main.OView.terrainAlpha = 1 - (terrainAlpha / 100);
    }, [terrainAlpha]);

    return (
        <div style={{ marginBottom: "1rem" }}>
            <div className='slider-description'>圖台透明度： {terrainAlpha} %</div>
            <Slider id="EDLScale" value={terrainAlpha} onChange={(e) => setTerrainAlpha(e.value)} min={0} max={100} />
        </div>
    )
}